<!-- <nav class="navbar navbar-expand-lg modern-nav">
    <div class="container-fluid">
        <div class="navbar-brand-wrapper">
            <i class="bi bi-gear-wide-connected icon-management"></i>
            <span class="brand-text">Rules Management</span>
        </div>
    </div>
</nav> -->

<div class="edit-hero">
    <div class="container">
         <div class="row align-items-center">
            <div class="col-md-6">
                <button class="btn btn-back" (click)="goBack()">
                    <i class="bi bi-arrow-left-circle-fill"></i>
                    <span>Back to Rules Dashboard</span>
                </button>
            </div>
            <div class="col-md-6 text-end">
                <button class="btn btn-hero-action" (click)="onCreateNew()">
                    <i class="bi bi-plus-circle-fill"></i>
                    <span>Create New Rule</span>
                </button>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="hero-content">
                    <h1 class="hero-title">
                        <i class="bi bi-bezier2 hero-icon"></i>
                        {{displayName}} Management
                    </h1>
                    <p class="hero-subtitle">Create, edit, and manage {{displayName.toLowerCase()}} with ease</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container management-container">

    <!-- Loading indicator -->
    <div *ngIf="loading" class="loader-overlay">
        <div class="spinner-wrapper">
            <div class="spinner-border text-light" role="status"></div>
            <p class="loading-text">Loading rules...</p>
        </div>
    </div>

    <!-- System Filter and Article ID Search (only for mating rules) -->
    <div class="row mb-4" *ngIf="!loading && (ruleType === 'mating' || ruleType === 'joint')">
        <div class="col-md-12">
            <div class="filter-card">
                <div class="filter-card-header">
                    <i class="bi bi-funnel-fill filter-icon"></i>
                    <h5 class="filter-title">Filters</h5>
                </div>
                <div class="filter-card-body">
                    <div class="row">
                        <div class="col-md-6" *ngIf="ruleType === 'mating' || ruleType === 'joint'">
                            <div class="form-group-modern">
                                <label for="systemFilter" class="form-label-modern">
                                    <i class="bi bi-diagram-3"></i>
                                    Filter by System
                                </label>
                                <select
                                    class="form-control-modern"
                                    id="systemFilter"
                                    [(ngModel)]="selectedSystemId"
                                    (ngModelChange)="onSystemFilterChange($event)"
                                    name="systemFilter">
                                    <option value="">All Systems</option>
                                    <option *ngFor="let system of systems" [value]="system.id">
                                        {{ system.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6" *ngIf="ruleType === 'mating' || ruleType === 'joint'">
                            <div class="form-group-modern">
                                <label for="articleIdSearch" class="form-label-modern">
                                    <i class="bi bi-search"></i>
                                    Search by Article ID
                                </label>
                                <input
                                    type="text"
                                    class="form-control-modern"
                                    id="articleIdSearch"
                                    [(ngModel)]="searchArticleId"
                                    (ngModelChange)="onArticleIdSearchChange($event)"
                                    placeholder="Enter article ID to search..."
                                    name="articleIdSearch">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Rules Table -->
    <div class="row" *ngIf="!loading">
        <div class="col-md-12">
            <div class="modern-table-card">
                <div class="table-card-header">
                    <div class="table-title-wrapper">
                        <i class="bi bi-table table-icon"></i>
                        <h5 class="table-title">Rules List</h5>
                    </div>
                    <span class="table-badge">
                        {{filteredRules.length}} {{(selectedSystemId || (ruleType === 'mating' && searchArticleId)) ? 'filtered' : 'total'}} rules
                    </span>
                </div>
                <div class="table-card-body">
                    <div class="modern-table-wrapper" *ngIf="filteredRules.length > 0">
                        <table class="modern-table">
                            <thead>
                                <tr>
                                    <th (click)="onSort(ruleType === 'mating' || ruleType === 'joint' ? 'name' : 'id')" 
                                        class="sortable-header">
                                        {{ruleType === 'mating' || ruleType === 'joint' ? 'Rule Name' : 'ID'}}
                                        <i class="bi sort-icon" [ngClass]="getSortIcon(ruleType === 'mating' ? 'name' : 'id')"></i>
                                    </th>
                                    <th *ngIf="ruleType === 'mating'" (click)="onSort('crossSections')" 
                                        class="sortable-header">
                                        Cross Sections
                                        <i class="bi sort-icon" [ngClass]="getSortIcon('crossSections')"></i>
                                    </th>
                                    <th *ngIf="ruleType === 'joint'" (click)="onSort('jointSections')" 
                                        class="sortable-header">
                                        Joint Sections
                                        <i class="bi sort-icon" [ngClass]="getSortIcon('jointSections')"></i>
                                    </th>
                                    <th *ngIf="ruleType === 'mating' || ruleType === 'joint'" 
                                        (click)="onSort('system')" 
                                        class="sortable-header">
                                        System
                                        <i class="bi sort-icon" [ngClass]="getSortIcon('system')"></i>
                                    </th>
                                    <th (click)="onSort('createdAt')" 
                                        class="sortable-header">
                                        Created At
                                        <i class="bi sort-icon" [ngClass]="getSortIcon('createdAt')"></i>
                                    </th>
                                    <th (click)="onSort('updatedAt')" 
                                        class="sortable-header">
                                        Updated At
                                        <i class="bi sort-icon" [ngClass]="getSortIcon('updatedAt')"></i>
                                    </th>
                                    <th style="max-width: 100px;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let rule of filteredRules" 
                                    [style.backgroundColor]="(ruleType === 'mating' || ruleType === 'joint') && getRuleHighlightColor(rule) ? (getRuleHighlightColor(rule) + '30') : ''"
                                    [style.border-left]="(ruleType === 'mating' || ruleType === 'joint') && getRuleHighlightColor(rule) ? ('5px solid ' + getRuleHighlightColor(rule)) : ''"
                                    [title]="(ruleType === 'mating' || ruleType === 'joint') && getRuleDuplicateArticleIds(rule).length > 0 ? ('Duplicate Article ID(s): ' + getRuleDuplicateArticleIds(rule).join(', ')) : ''">
                                    <td><strong>{{ruleType === 'mating' || ruleType === 'joint' ? getRuleName(rule) : rule.id}}</strong></td>
                                    <td>
                                        <span class="modern-badge badge-primary">{{getCrossSectionsCount(rule)}}</span>
                                    </td>
                                    <td *ngIf="ruleType === 'mating' || ruleType === 'joint'">
                                        <span *ngIf="getRuleSystemId(rule)">
                                            {{getSystemName(getRuleSystemId(rule) || '')}}
                                        </span>
                                        <span *ngIf="!getRuleSystemId(rule)" class="text-muted">No System</span>
                                    </td>
                                    <td>
                                        <span *ngIf="rule.createdAt">{{rule.createdAt | date:'short'}}</span>
                                        <span *ngIf="!rule.createdAt">N/A</span>
                                    </td>
                                    <td>
                                        <span *ngIf="rule.updatedAt">{{rule.updatedAt | date:'short'}}</span>
                                        <span *ngIf="!rule.updatedAt">N/A</span>
                                    </td>
                                    <td style="max-width: 100px;">
                                        <div class="btn-group-modern">
                                            <button class="btn-modern-action btn-action-secondary" (click)="onEdit(rule)"
                                                title="Edit Rule">
                                                <i class="bi bi-pencil-fill"></i>
                                            </button>
                                            <button class="btn-modern-action btn-action-danger-secondary" (click)="onDelete(rule)"
                                                title="Delete Rule">
                                                <i class="bi bi-trash-fill"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Empty state -->
                    <div *ngIf="filteredRules.length === 0" class="empty-state">
                        <i class="bi bi-inbox empty-icon"></i>
                        <h4 class="empty-title">No rules found</h4>
                        <p class="empty-description">Start by creating your first rule to get started.</p>
                        <button class="btn-empty-action" (click)="onCreateNew()">
                            <i class="bi bi-plus-circle-fill"></i>
                            Create First Rule
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Duplicate Article IDs Legend (only for mating rules) -->
    <div class="row mt-4" *ngIf="!loading && (ruleType === 'mating' || ruleType === 'joint') && duplicateArticleIds.size > 0">
        <div class="col-md-12">
            <div class="legend-card">
                <div class="legend-card-header">
                    <i class="bi bi-exclamation-triangle-fill"></i>
                    <h5>Duplicate Article IDs Legend</h5>
                </div>
                <div class="legend-card-body">
                    <p class="legend-description">
                        The following article IDs are used in more than one rule. Rules sharing the same article ID are highlighted with the same color.
                    </p>
                    <div class="row">
                        <div class="col-md-6 col-lg-4 mb-3" *ngFor="let item of getDuplicateArticleIdsList()">
                            <div class="legend-item" 
                                 [style.backgroundColor]="item.color + '20'"
                                 [style.border]="'2px solid ' + item.color">
                                <div class="d-flex align-items-center">
                                    <div class="legend-color-box me-3 flex-shrink-0" 
                                         [style.width]="'40px'"
                                         [style.height]="'40px'"
                                         [style.backgroundColor]="item.color"
                                         [style.border]="'3px solid #fff'">
                                    </div>
                                    <div class="flex-grow-1">
                                        <strong style="color: #2d3748;">Article ID:</strong> 
                                        <strong style="color: #000;">{{ item.articleId }}</strong><br>
                                        <small class="text-muted">Used in {{ item.ruleCount }} rule(s)</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Create Rule Modal -->
<div class="modal fade" [class.show]="showCreateForm" [style.display]="showCreateForm ? 'block' : 'none'" tabindex="-1"
    *ngIf="showCreateForm">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header modern-modal-header">
                <h5 class="modal-title">
                    <i class="bi bi-plus-circle me-2"></i>
                    Create New {{displayName}}
                </h5>
                <button type="button" class="btn-close btn-close-dark" (click)="cancelCreate()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <app-rule-form [ruleType]="ruleType" [ruleData]="null" [isEditMode]="false" [selectedSystemId]="selectedSystemId"
                    (save)="onRuleFormSave($event)" (cancel)="cancelCreate()" [existingRules]="rules">
                </app-rule-form>
            </div>
        </div>
    </div>
</div>

<!-- Edit Rule Modal -->
<div class="modal fade" [class.show]="showEditForm" [style.display]="showEditForm ? 'block' : 'none'" tabindex="-1"
    *ngIf="showEditForm">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header modern-modal-header">
                <h5 class="modal-title">
                    <i class="bi bi-pencil-square me-2"></i>
                    Edit {{displayName}}
                </h5>
                <button type="button" class="btn-close btn-close-dark" (click)="cancelEdit()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <app-rule-form [ruleType]="ruleType" [ruleData]="editingRule" [isEditMode]="true"
                    (save)="onRuleFormUpdate($event)" (cancel)="cancelEdit()" [existingRules]="rules">
                </app-rule-form>
            </div>
        </div>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal fade" [class.show]="showDeleteConfirm" [style.display]="showDeleteConfirm ? 'block' : 'none'"
    tabindex="-1" *ngIf="showDeleteConfirm">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header modern-modal-header bg-danger text-white">
                <h5 class="modal-title">
                    <i class="bi bi-exclamation-triangle me-2"></i>
                    Confirm Delete
                </h5>
                <button type="button" class="btn-close btn-close-white" (click)="cancelDelete()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete this rule?</p>
                <div class="alert alert-warning">
                    <strong>Warning:</strong> This action cannot be undone.
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
                <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal backdrop -->
<div class="modal-backdrop fade" [class.show]="showCreateForm || showEditForm || showDeleteConfirm"
    *ngIf="showCreateForm || showEditForm || showDeleteConfirm"></div>